<template>
<div class="chapter">
<div class="inner_page">
<div id="ded">
<br/><br/><br/><br/><br/>
<p class="Dedication"><span class="Italics _idGenCharOverride-1">This book was written and dedicated to the loving memory of</span></p>
<p class="Dedication"><span class="Italics _idGenCharOverride-1">Skipper Sanders</span></p>
<p class="Dedication"><span class="Italics _idGenCharOverride-1">Rocky Sanders</span></p>
<p class="Dedication"><span class="Italics _idGenCharOverride-1">Sol Angel Peña Gutierrez</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-ded.vue?0c713663